import { render, staticRenderFns } from "./FoundMessage.vue?vue&type=template&id=0c4900b2&scoped=true&"
import script from "./FoundMessage.vue?vue&type=script&lang=js&"
export * from "./FoundMessage.vue?vue&type=script&lang=js&"
import style0 from "./FoundMessage.vue?vue&type=style&index=0&id=0c4900b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4900b2",
  null
  
)

export default component.exports